export const BlackDomeStatuses = [
	{ label: "Assigned", color: "blue", value: "assigned" },
	{ label: "Unassigned", color: "gray", value: "unassigned" },
	{ label: "In Field", color: "blue", value: "inField" },
	{ label: "Ready Office", color: "yellow.400", value: "readyOffice" },
	{ label: "Invoiced", color: "orange", value: "invoiced" },
	{ label: "Closed", color: "green", value: "closed" },
	{ label: "Response Needed", color: "borderColor", value: "needsResponse" },
]
